import {
  FlatAspect,
  ItemAttributeOption,
} from "@/models/HomePageSearchResponse";

export const OTT_DISCIPLINE = {
  id: "234",
  label: "Off the track",
  slug: "off-the-track",
};

const DISCIPLINE_OPTIONS: FlatAspect[] = [
  { id: "140", label: "Adult riding club", slug: "adult-riding-club" },
  { id: "142", label: "All Rounder", slug: "all-rounder" },
  { id: "143", label: "Breeding", slug: "breeding" },
  { id: "216", label: "Campdraft", slug: "campdraft" },
  { id: "214", label: "Cutting", slug: "cutting" },
  { id: "144", label: "Dressage", slug: "dressage" },
  { id: "163", label: "Driving/Harness", slug: "driving-harness" },
  { id: "154", label: "Endurance", slug: "endurance" },
  { id: "145", label: "Eventing", slug: "eventing" },
  { id: "221", label: "Hunter", slug: "hunter" },
  { id: "interschool", label: "Interschool", slug: "interschool" },
  OTT_DISCIPLINE,
  { id: "158", label: "Other", slug: "other-discipline" },
  { id: "152", label: "Polo", slug: "polo" },
  { id: "153", label: "Polocrosse", slug: "polocrosse" },
  { id: "151", label: "Pony Club", slug: "pony-club" },
  { id: "236", label: "Racing", slug: "racing" },
  { id: "215", label: "Reining", slug: "reining" },
  { id: "161", label: "Rodeo/Barrel racing", slug: "rodeo-barrel-racing" },
  { id: "211", label: "School Master", slug: "school-master" },
  { id: "160", label: "Show", slug: "show" },
  { id: "146", label: "Showjumping", slug: "showjumping" },
  { id: "213", label: "Trail riding/pleasure", slug: "trail-riding-pleasure" },
  { id: "249", label: "Western All Rounder", slug: "western-all-rounder" },
  { id: "212", label: "Western Pleasure", slug: "western-pleasure" },
  { id: "248", label: "Western Show", slug: "western-show" },
];

export default DISCIPLINE_OPTIONS;

export const DISCIPLINE_ATTRIBUTE_OPTIONS: ItemAttributeOption[] =
  DISCIPLINE_OPTIONS.map((discipline) => ({
    value: discipline.id,
    label: discipline.label,
  }));
